import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiImageSize } from '@fi-shared/types';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { MediaBankHelperService } from '@fi-shared/media-bank/media-bank-helper.service';
import { IChecklist2ReportAnswer } from '../../../shared/fi-checklist2-report';
import { FiChecklist2ReportHelperService } from '../../../services/fi-checklist2-report-helper.service';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';

export interface IChecklistReportAttachmentDetailsDialogData {
    answerDetails: IChecklist2ReportAnswer;
    mediaBankFileReference: IMediaBankFileReference;
}

@Component({
    selector: 'fi-checklist-attachment-details-dialog',
    templateUrl: './checklist-attachment-details-dialog.component.html',
    styleUrls: ['./checklist-attachment-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-attachment-details-dialog' },
    standalone: false,
})
export class FiChecklistAttachmentDetailsDialogComponent
    extends FiDialogsContentBase<IChecklistReportAttachmentDetailsDialogData, void>
    implements OnInit
{
    get currentMediaBankFileReference(): IMediaBankFileReference {
        return this.data.mediaBankFileReference;
    }

    ngOnInit() {
        this.setServices();
    }

    getAnswerStatusLabel(): string {
        return this.fiChecklist2ReportHelperService.getAnswerStatusLabel(this.data.answerDetails.AnswerStatus);
    }

    isAutomatedTasksAdded(): boolean {
        return !!this.data.answerDetails.OneTimeTaskIds?.length || !!this.data.answerDetails.CheckpointActions?.length;
    }

    isVimeoMediaBankRef(): boolean {
        return this.fiMediaStorageService.isVimeoStorage(this.currentMediaBankFileReference.StorageType);
    }

    download() {
        this.mediaBankHelper.downloadMediaBankFileRef(this.currentMediaBankFileReference);
    }

    private fiMediaStorageService: FiMediaStorageService;
    private mediaBankHelper: MediaBankHelperService;
    private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService;

    private setServices() {
        this.fiMediaStorageService = this.injector.get(FiMediaStorageService);
        this.mediaBankHelper = this.injector.get(MediaBankHelperService);
        this.fiChecklist2ReportHelperService = this.injector.get(FiChecklist2ReportHelperService);
    }

    protected readonly FiDateTimeFormatOptions = FiDateTimeFormatOptions;
    protected readonly FiImageSize = FiImageSize;
}
